import BaseFormPage from "../../base/BaseFormPage";
import ConfirmationDialog from "../../components/ConfirmationDialog/ConfirmationDialog";
import dialog from "../../components/Modal/dialog";
import createPromise from "../createPromise";

export default class FormUtils extends BaseFormPage {
  constructor() {
    super();
    this.fieldsToExclude = [
      "id",
      "createdAt",
      "updatedAt",
      "acl",
      "code",
      // "clientCode",
      // "isShowOutSide",
    ];
  }

  isEditing() {
    if (this.getParams().id) {
      return true;
    } else return false;
  }

  formatObjectRoles(object) {
    if (Object.keys(object).length < 1) return;

    return {
      ...object,
      roles: object.roles[0],
    };
  }

  transformFieldsToSections(data) {
    const sections = {};

    for (const [fieldKey, fieldValue] of Object.entries(data.fields)) {
      if (fieldValue.section) {
        const sectionName = fieldValue.section;
        if (!sections[sectionName]) {
          sections[sectionName] = { name: sectionName, fields: {} };
        }
        sections[sectionName].fields[fieldKey] = fieldValue;
      } else {
        if (!sections[""]) {
          sections[""] = { name: "", fields: {} };
        }
        sections[""].fields[fieldKey] = fieldValue;
      }
    }

    return Object.values(sections);
  }

  showConfirmationDialog(props) {
    const title = props?.title || "Save Changes";
    const message =
      props?.message || "Are you sure you want to save the changes?";

    const promise = createPromise();
    dialog.fire({
      html: <ConfirmationDialog title={title} message={message} />,
      onPositiveClick: () => {
        promise.resolve();
      },
      onNegativeClick: () => {
        promise.reject();
      },
    });

    return promise;
  }

  // showSuccessSnackbar(heading, message) {
  //   const promise = createPromise();
  //   dialog.fire({
  //     html: <p>Hakdog</p>,
  //     negativeButton: false,
  //     onPositiveClick: () => {
  //       promise.resolve();
  //     },
  //     onNegativeClick: () => {
  //       promise.reject();
  //     },
  //   });

  //   return promise;
  // }

  getAcl() {
    const user = this.getCurrentUser();
    return {
      read: ["*"],
      write: [user.id, "role:admin"],
    };
  }
}
